import * as yup from 'yup';

import { RevenueShareType } from 'src/api';

import { EmployerInitialBillingFormFields, VerifierBillingRulesFormFields } from '../types';

const NO_MORE_THAN_TWO_DECIMAL_DIGITS_REGEXP = /^\d+(\.\d{0,2})?$/;

export const VerifierInitialBillingRulesValidationSchema = yup.object().shape({
  [VerifierBillingRulesFormFields.voI]: yup
    .number()
    .transform(value => (Number.isNaN(value) ? undefined : value))
    .test('maxDigitsAfterDecimal', 'Must have no more than 2 digits after decimal', value => {
      if (!value) {
        return false;
      }
      return NO_MORE_THAN_TWO_DECIMAL_DIGITS_REGEXP.test(value.toString());
    })
    .positive('Should be positive')
    .required('Verification of Income Field is required'),
  [VerifierBillingRulesFormFields.voE]: yup
    .number()
    .transform(value => (Number.isNaN(value) ? undefined : value))
    .test('maxDigitsAfterDecimal', 'Must have no more than 2 digits after decimal', value => {
      if (!value) {
        return false;
      }
      return NO_MORE_THAN_TWO_DECIMAL_DIGITS_REGEXP.test(value.toString());
    })
    .positive('Should be positive')
    .required('Verification of Employment Field is required'),
  [VerifierBillingRulesFormFields.reverification]: yup
    .number()
    .transform(value => (Number.isNaN(value) ? undefined : value))
    .test('maxDigitsAfterDecimal', 'Must have no more than 2 digits after decimal', value => {
      if (!value) {
        return false;
      }
      return NO_MORE_THAN_TWO_DECIMAL_DIGITS_REGEXP.test(value.toString());
    })
    .positive('Should be positive')
    .required('Reverification Field is required'),
});

export const EmployerInitialBillingRulesValidationSchema = yup.object({
  [EmployerInitialBillingFormFields.revenueShareType]: yup.string(),
  [EmployerInitialBillingFormFields.revenueShare]: yup
    .number()
    .when([EmployerInitialBillingFormFields.revenueShareType], {
      is: (revenueShareType: RevenueShareType) => revenueShareType === RevenueShareType.Percents,
      then: schema =>
        schema
          .max(100, 'The value should not be more than 100')
          .transform(value => (Number.isNaN(value) ? undefined : value))
          .test('maxDigitsAfterDecimal', 'Must have no more than 2 digits after decimal', value => {
            if (!value) {
              return false;
            }
            return NO_MORE_THAN_TWO_DECIMAL_DIGITS_REGEXP.test(value.toString());
          })
          .positive('Should be positive')
          .required('Revenue Share Field is required'),
      otherwise: schema =>
        schema
          .transform(value => (Number.isNaN(value) ? undefined : value))
          .test('maxDigitsAfterDecimal', 'Must have no more than 2 digits after decimal', value => {
            if (!value) {
              return false;
            }
            return NO_MORE_THAN_TWO_DECIMAL_DIGITS_REGEXP.test(value.toString());
          })
          .positive('Should be positive')
          .required('Revenue Share Field is required'),
    }),
});
